import React from "react";
import erpI from '../../images/home/erp.png';

function ERPBusiness() {
  return (
    <>

      <ServiceHero />

      <section className="service-content-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={erpI}
                alt="ERP and Business Management"
                className="service-main-image"
              />
            </div>

            <div className="col-lg-6">
              <div className="service-content">

                <h2>Manage Your Business From One Place</h2>

                <p>
                  ERP and business management solutions help bring important
                  business operations together in one centralized system.
                </p>

                <p>
                  Manage customers, products, inventory, sales, purchases,
                  employees, and other business processes with software
                  designed around your organization.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-features-section">
        <div className="container">
          <div className="section-heading text-center">

            <h2>Business Operations Made Simpler</h2>
          </div>

          <div className="row g-4">
            {[
              ["Inventory Management", "Monitor products, stock levels, and inventory movements."],
              ["Sales Management", "Manage customers, quotations, orders, invoices, and sales."],
              ["Purchase Management", "Organize suppliers, purchases, and purchasing workflows."]
            ].map(([title, text]) => (
              <div className="col-lg-4 col-md-6" key={title}>
                <div className="service-feature-card">
                  <h3>{title}</h3>
                  <p>{text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ServiceCTA />
    </>
  );
}

function ServiceHero() {
  return (
    <section
      className="service-page-hero"
      style={{ backgroundColor: '#002952' }}
    >
      <div className="container">
        <div className="service-hero-content">
          <h1>ERP & Business Management</h1>
          <p style={{ color: '#FF7D37' }}>
            Integrated business solutions designed to <br />simplify operations and
            improve productivity.
          </p>
        </div>
      </div>
    </section>
  );
}

function ServiceCTA() {
  return <CTA />;
}

function CTA() {
  return (
    <section className="service-cta-section">
      <div className="container">
        <div className="service-cta-box">
          <div>
            <span>BUSINESS SOLUTIONS</span>
            <h2>Ready To Improve Your Business?</h2>
            <p>Let's discuss your business requirements.</p>
          </div>
          <a href="/contactus" className="service-cta-button">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default ERPBusiness;